import { useEffect } from 'react';

export function useAuraluxClientEffects() {
  useEffect(() => {
    const nav = document.getElementById('nav');
    const onScroll = () => {
      if (!nav) return;
      nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.rv,.rl,.rr').forEach((el, i) => {
      el.style.transitionDelay = `${(i % 6) * 70}ms`;
      obs.observe(el);
    });

    const bObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('.bar-fill').forEach((b) => {
            b.style.width = `${b.dataset.w}%`;
          });
          bObs.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );
    const pb = document.getElementById('pbars');
    if (pb) bObs.observe(pb);

    return () => {
      window.removeEventListener('scroll', onScroll);
      obs.disconnect();
      bObs.disconnect();
    };
  }, []);
}
